// Web Push (VAPID) client utilities.
import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function pushPermission() {
  return typeof Notification !== "undefined" ? Notification.permission : "default";
}

export async function ensureServiceWorker() {
  if (!("serviceWorker" in navigator)) throw new Error("Browser tidak mendukung service worker");
  const existing = await navigator.serviceWorker.getRegistration("/sw.js");
  if (existing) return existing;
  return await navigator.serviceWorker.register("/sw.js", { scope: "/" });
}

export async function getPushSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) return null;
  return await reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Browser tidak mendukung Web Push");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Izin notifikasi ditolak");
  const reg = await ensureServiceWorker();
  // Fetch VAPID public key from server
  const { data: keyResp } = await api.get("/push/public-key");
  if (!keyResp?.publicKey) throw new Error("VAPID belum dikonfigurasi di server");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(keyResp.publicKey),
    });
  }
  // Send to server
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getPushSubscription();
  if (!sub) return { ok: true, alreadyGone: true };
  try {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
  } catch (_) {}
  await sub.unsubscribe();
  return { ok: true };
}

export async function sendTestPush() {
  const r = await api.post("/push/test", {});
  return r.data;
}
